import React from 'react'

import MetaTags from '../helpers/MetaTags'

export default function HeaderFirst(props) {
  const { pageMeta, dynamicData, title } = props

  return (
    <>
      {pageMeta ? (
        <MetaTags
          meta={pageMeta}
          title={title}
          tags={pageMeta.tags}
          canonicalUri={dynamicData.canonicalUri}
          structuredData={dynamicData.structuredData}
        />
      ) : null}
    </>
  )
}
